export default "__VITE_ASSET__DZvxoEvo__"